<template>
  <v-draggable>
    <v-window ref="window" defaultClosed :class="$style.wrapper" width="35.5rem" title="Calendar">
      <div :class="$style.inner">
        <div :class="$style.title">Создать напоминание о смене пароля</div>
        <v-select :error="errorSelect" :items="items" v-model="selected" placeholder="Выберите интервал" />
        <v-check :error="errorRepeat" :class="$style.check" v-model="repeat" lg>Повторять оповещение</v-check>
        <v-btn large color="green" @click="check">Создать</v-btn>
      </div>

      <v-help ref="errorBox" button="Ok">{{errorText}}</v-help>
      <portal to="outer">
        <transition name="bounce">
          <div :class="$style.push" v-if="showPush">
            <div :class="$style.top">
              <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8894 8.955L6.65532 0.422496C6.30696 -0.146124 5.73714 -0.138144 5.38879 0.430477L0.154683 8.95141C-0.193672 9.52043 0.0664972 9.95976 0.732881 9.95976H11.3108C11.9776 9.95976 12.2378 9.52322 11.8894 8.955ZM6.01766 2.31112C6.35285 2.31112 6.61222 2.68142 6.59506 3.13392L6.48892 5.8609C6.47176 6.31301 6.25908 6.68331 6.01647 6.68331C5.77385 6.68331 5.56077 6.31301 5.54361 5.8609L5.43867 3.13392C5.42151 2.68142 5.68168 2.31112 6.01766 2.31112ZM6.01766 8.73753C5.59469 8.73753 5.30459 8.42828 5.31337 8.0057C5.31337 7.57395 5.60427 7.27388 6.01766 7.27388C6.44862 7.27388 6.72116 7.57395 6.73033 8.0057C6.73033 8.42828 6.44862 8.73753 6.01766 8.73753Z" fill="#FF0000"/>
              </svg>
              Напоминание
            </div>
            Сменить пароль – <br>
            {{ selected ? formatLongDate(selected.date) : '' }}
          </div>
        </transition>
      </portal>
    </v-window>
  </v-draggable>
</template>
<script>
import days from '@/utils/days'

const secondsInDay = 3600 * 1000 * 24

const dates = [
  new Date(Date.now() + secondsInDay),
  new Date(Date.now() + secondsInDay * 7),
  new Date(Date.now() + secondsInDay * 30),
  new Date(Date.now() + secondsInDay * 30 * 3),
  new Date(Date.now() + secondsInDay * 30 * 6),
  new Date(Date.now() + secondsInDay * 30 * 12),
]

const formatDate = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  return `${day}.${month}.${year}`
}

const monthes = (month) => {
  const mm = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ]
  return mm[month]
}

const formatLongDate = (date) => {
  const day = days(date.getDay())
  const dayOfMonth = date.getDate()
  const month = monthes(date.getMonth())

  return `${day}, ${dayOfMonth} ${month}`
}

export default {
  name: 'calendar',
  props: {
    data: Object,
  },
  data: () => ({
    repeat: false,
    errorRepeat: false,
    errorSelect: false,
    selected: null,
    errorText: '',
    showPush: false,
    formatLongDate,
    items: [
      {
        label: `${formatDate(dates[1])} (через неделю)`,
        value: 1,
        date: dates[1],
      },
      {
        label: `${formatDate(dates[2])} (через месяц)`,
        value: 2,
        date: dates[2],
      },
      {
        label: `${formatDate(dates[3])} (через 3 месяца)`,
        value: 3,
        date: dates[3],
      },
      {
        label: `${formatDate(dates[4])} (через полгода)`,
        value: 4,
        date: dates[4],
      },
      {
        label: `${formatDate(dates[5])} (через год)`,
        value: 5,
        date: dates[5],
      },
    ],
  }),
  methods: {
    open() {
      this.$refs.window.open()
      this.data.tasks[9].current = true
      this.$emit('box', 'box4')
    },
    close() {
      this.$refs.window.close()
      this.data.tasks[9].current = false
    },
    runError(error) {
      this.$refs.errorBox.open()
      this.errorText = error
    },
    check() {
      this.$refs.errorBox.close()
      this.errorRepeat = false
      this.errorSelect = false

      setTimeout(() => {
        const { repeat, selected } = this

        if (selected.value > 4) {
          this.errorSelect = true
          this.runError('Напоминание произойдет слишком поздно')
          return
        }

        if (!repeat) {
          this.errorRepeat = true
          this.runError('Необходимо повторять напоминание')
          return
        }

        this.showPush = true
        this.data.tasks[9].ready = true
        this.$store.commit('SET_RESULT', 5)
        this.close()

        setTimeout(() => {
          this.$emit('success')
        }, 1000)
      }, 500)
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  left: 68.8rem;
  top: 33.2rem;
  height: 45.9rem;
}

.inner {
  padding: 1.5rem;
  font-size: 1.6rem;
  margin-top: 6rem;

  & > button {
    display: block;
    margin: 0 auto;
    margin-top: 4.2rem;
  }
}

.title {
  margin-bottom: 1rem;
}

.check {
  margin-top: 1rem;
}

.push {
  position: fixed;
  top: 6rem;
  right: 2rem;
  background: #FFFFFF;
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 1rem;
  width: 23.5rem;
  font-size: 1.4rem;
  line-height: 1.2142857143;
}

.top {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: rgba(#000, .3);
  margin-bottom: 0.5rem;

  svg {
    width: 1.2rem;
    height: auto;
    margin-right: 0.5rem;
  }
}
</style>
